import { render, staticRenderFns } from "./MedPrescribingInfo.vue?vue&type=template&id=6590a2f9&scoped=true&"
import script from "./MedPrescribingInfo.vue?vue&type=script&lang=ts&"
export * from "./MedPrescribingInfo.vue?vue&type=script&lang=ts&"
import style1 from "./MedPrescribingInfo.vue?vue&type=style&index=1&id=6590a2f9&lang=scss&rel=stylesheet&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6590a2f9",
  null
  
)

export default component.exports